import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  Account,
  AccountGroupMembership,
} from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';

@Component({
  selector: 'app-profile-hub-settings-dialog',
  templateUrl: './profile-hub-settings-dialog.component.html',
})
export class ProfileHubSettingsDialogComponent implements OnInit {
  profile: Account;
  user: Account;
  membership: AccountGroupMembership;
  group: Group;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      user: Account;
      profile: Account;
      group: Group;
      membership: AccountGroupMembership;
      isIntroOnly: boolean;
    },
    private dialogRef: MatDialogRef<ProfileHubSettingsDialogComponent>,
  ) {}

  ngOnInit() {
    this.profile = this.data.profile;
    this.user = this.data.user;
    this.membership = this.data.membership;
    this.group = this.data.group;
  }

  closeDialog({ isRemoved }: { isRemoved: any }) {
    this.dialogRef.close(isRemoved);
  }
}
